export default __webpack_public_path__ + "static/beatport-1e153071950d5341067563a4db3cfa3f.png";